export var isValidDate=function(i){return void 0!==i&&!isNaN(i.getTime())};